<template>
	<div class="panel_shouyin">
		<!-- <div class="titleLine">
			<el-row>
				<el-col :span="6" style="padding:20px 20px;font-size: 16px;color:#333;">
					会员充值
				</el-col>
				<el-col :span="3" :offset="15" style="padding:10px 10px;">
					<el-button @click="back" size="mini" style="margin-left:40px;">返回</el-button>
				</el-col>
			</el-row>
		</div> -->
		<div class="con">
			<el-row style="padding:0px 40px 10px;background-color: #ffffff;line-height: 40px;width:100%;" >
				<el-col :span="24">
					<span>销售人员：</span>
					<span>
						<el-select class="select" style="width:200px;" multiple v-model="curStaff" filterable placeholder="请选择" size="mini">
							<el-option popper-class="select" v-for="(item,index) in staffList" :key="item._id" :label="item.basic_info.nick_name"
							:value="index">
							</el-option>
						</el-select>
					</span>
				</el-col>
			</el-row>
			<el-row style="padding:0px 40px 10px;background-color: #ffffff;line-height: 40px;width:100%;" >
				<el-col :span="24">
					<!-- <span>充值活动：</span> -->
					<span class="rechargeBox">
						<div
						class="rechargeItem"
						:class="[curActivity._id===item._id?'active':'']"
						v-for="(item,index) in activityList"
						:key="index"
						@click="changeActivity(item)">
							<div>{{item.name}}</div>
							<div style="line-height: 38px;font-size: 12px;">
								<span v-if="item.give_goods!==null&&item.give_goods.give_list.length>0"> 有赠品 </span>
								<span v-else-if="item.give_goods!==null&&item.give_goods.give_living_list.length>0"> 赠活体 </span>
								<span v-else>无赠品</span>
							</div>
							<img class="checked"
							v-if="curActivity._id===item._id"
							src="../../../../assets/img/bottomRightChecked.png"
							>
							<img class="checked"
							v-else
							src="../../../../assets/img/bottomRightNoChecked.png"
							>
						</div>
					</span>
				</el-col>
			</el-row>
			
			<div v-if="tableData.length>0">
				<div style="padding:20px 20px 10px;font-size: 16px;">
					赠品
					<span style="color:red" v-if="curActivity.give_goods.give_type===1||curActivity.give_goods.give_type===3">
						( 以下商品可赠送{{curActivity.give_goods.give_count}}件 )
					</span>
				</div>
				<div style="padding:10px 0;">
					<el-table :data="tableData"  style="width: 100%;margin-bottom: 20px;" row-key="tableKey" size="mini">
						<el-table-column prop="goodsName" label="名称" width="400">
						</el-table-column>
						<el-table-column prop="skuValue" label="规格">
						</el-table-column>
						<el-table-column prop="num" label="数量" width="300">
							<template slot-scope="props">
								<el-input-number v-model="props.row.num" controls-position="right" :min="0" size="small" @change="inputNum(props)"></el-input-number>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<div class="panel_settlement">
			<div style="padding-top:7px;">
				
			</div>
			<div>
				<span class="priceItem" style="margin-right: 20px;">
					<span class="label">应付金额：</span>
					<span class="price" style="color:#FF2F2F;">￥{{curActivity.activity_recharge.price}}</span>
				</span>
				<el-button style="width:80px;" type="warning" size="small" plain @click="openBeizhu">备注</el-button>
				<el-button style="width:100px;" type="warning" size="small" plain @click="giftCardRecharge_state=true">活体卡充值</el-button>
				<el-button style="width:100px;" type="warning" size="small" plain @click="submitOrder">生成订单</el-button>
				<el-button style="width:80px;" type="warning" size="small" @click="submitOrderAndSettlement">结算</el-button>
			</div>
		</div>
		<!-- 礼品卡充值 -->
		<div v-if="giftCardRecharge_state">
			<giftCardRecharge @submit="submit_giftCardRecharge"></giftCardRecharge>
		</div>
		<!-- 备注弹窗 -->
		<div v-if="drawerRemark_state">
			<drawerRemark :type="'recharge'" @submit="submit_drawerRemark"></drawerRemark>
		</div>
		<!-- 结算弹窗 -->
		<div>
			<dialogSettlement v-if="dialogSettlementState" :type="'recharge'" :canYue="false" :orderId="order._id" @submit="dialogSettlementSubmit"></dialogSettlement>
		</div>
	</div>
</template>
<script>
	import dialogSettlement from "../../../../components/dialog_settlement.vue"
	import drawerRemark from "../drawer/remark.vue"
	import giftCardRecharge from "../drawer/giftCardRecharge.vue"
	import del from "../../../../util/del.js"
	export default {
		components:{dialogSettlement,drawerRemark,giftCardRecharge},
		data(){
			return{
				// 充值活动
				curActivity:{_id:'',activity_recharge:{}},
				activityList:[],
				// 销售人员
				curStaff: [], 
				staffList: [],
				// 备注
				drawerRemark_state:'',
				tableData:[],
				o:null,
				// 结算
				dialogSettlementState:false,
				order:{},
				// 是否直接结算
				direct:false,
				// 礼品卡充值
				giftCardRecharge_state:false,
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
			remark(){
				return this.$store.state.recharge.remark;
			},
		},
		mounted(){
			let params = {
				"vipCardUser": this.userInfo.club_card.is_valid,
				"staff_type": this.userInfo.staff_type, // 1在职  2.离职
				"new_member": this.userInfo.isnew_member,
			}
			this.$http.post('/api/Activity/GetRecharge', params).then(res => {
				if (res.code == 0) {
					this.activityList = res.data;
				}
			})
			this.$http.get('/api/Staff/List', {
				"keyword": '', //关键字
				"pageIndex": 1,
				"pageSize": 1000,
			}).then(res => {
				if (res.code == 0) {
					this.staffList = res.data.data;
				}
			})
			this.o = new del();
		},
		methods: {
			back(){
				this.$store.commit('mendian/set_curBusiness','充值记录')
				this.$store.commit('recharge/set_type','list')
			},
			inputNum(props){
				// row.num = this.$public.FInt(row.num);
			  let num = 0;
					num += props.row.num;
				this.$set(this.tableData[props.$index],['num'],num);
			},
			// 活动
			changeActivity(item) {
				this.curActivity = item;
				let arr = []
				if(this.curActivity.give_goods!==null&&this.curActivity.give_goods.give_list.length>0){
					let table = this.curActivity.give_goods.give_list;
					for(let i=0;i<table.length;i++){
						let goods = {
							tableKey: 'tableKey'+Math.random(),
							goodsId:table[i].goods_id,
							goodsName:table[i].goods_name,
							goodsType:table[i].param_type_id,
							skus:table[i].skus,
							skuValue:table[i].sku_value,
							num:table[i].goods_count,
							unitId:table[i].packing_way_id,
							unit:table[i].packing_way_name,
							goodsList:[],
						}
						if(Number(table[i].param_type_id)===6||Number(table[i].param_type_id)===3){ // 卡或优惠券
							console.log('充值送卡或优惠券')
						}else{
							goods.checkGoods = JSON.parse(JSON.stringify(goods));
						}
						
						arr.push(goods)
					}
				}
				if(this.curActivity.give_goods!==null&&this.curActivity.give_goods.give_living_list.length>0){
					let table = this.curActivity.give_goods.give_living_list;
					for(let i=0;i<table.length;i++){
						let goods = {
							tableKey:table[i].eprom_no,
							goodsId:table[i].pet_id,
							goodsName:table[i].inside_name,
							goodsType:5,
							skus:'',
							skuValue:table[i].category_name,
							num:1,
							unitId:'',
							unit:'',
							goodsList:[],
						}
						arr.push(goods)
					}
				}
				this.o.init(arr)
				this.tableData = this.o.arr;
			},
	
			submitOrderAndSettlement(){
				this.direct = true;
				this.submitOrder();
			},
			// 提交
			submitOrder() {
				if (!this.curActivity._id) {
					this.$message({
						message: '请选择充值活动',
						type: 'error'
					});
					return;
				}
				if (this.curStaff.length === 0) {
					this.$message({
						message: '请选择销售人员',
						type: 'error'
					});
					return;
				}
				let order_item_list = [];
				console.log(this.tableData)
				if (this.tableData.length > 0) { // 送商品
					let table2 = [];
					for(let i=0;i<this.tableData.length;i++){
						if(
							(this.tableData[i].goodsType===0&&this.tableData[i].goodsList.length===0)||
							(this.tableData[i].goodsType===5&&this.tableData[i].goodsList.length===0)||
							(this.tableData[i].goodsType==3&&this.tableData[i].num===0)||
							(this.tableData[i].goodsType==6&&this.tableData[i].num===0)
							
						)
						{
							continue ;
						}
						let one = {
							"num": this.tableData[i].num,
							"price": this.tableData[i].price||0,
							"original_price": this.tableData[i].originalPrice||0,
							"skus": this.tableData[i].skus,
							"sku_value": this.tableData[i].skuValue,
							"goods_type": this.tableData[i].goodsType,
							"goods_id":this.tableData[i].goodsId,
							"goods_name": this.tableData[i].goodsName,
							"packing_way_id": this.tableData[i].unitId,
							"unit":this.tableData[i].unit,
							"remarks": '充值送',
							"order_item_goods_list": [],
						}
						if(this.curActivity.give_goods.give_type===1){
							one.num = this.tableData[i].num;
						}else if(this.curActivity.give_goods.give_type===3){
							one.num = this.tableData[i].num;
						}else{
							one.num = this.tableData[i].num;
						}
						table2.push(one)
					}
					order_item_list = table2
				}
				let sales_list = []
				for (let i = 0; i < this.curStaff.length; i++) {
					sales_list.push({
						sales_id: this.staffList[this.curStaff[i]]._id,
						sales_name: this.staffList[this.curStaff[i]].basic_info.nick_name,
					})
				}
				let params = {
					"activity_id": this.curActivity._id,
					"remark": this.remark,
					"user_info": {
						"user_id": this.userInfo._id,
						"nick_name": this.userInfo.basic_info.nick_name,
						"user_mobile": this.userInfo.basic_info.user_mobile,
					},
					"sales_list": sales_list,
					"order_item_list": order_item_list
				}
				console.log(params)
				let loading = this.$loading();
				this.$http.post('/api/Recharge/CreateOrderRecharge', params).then(res => {
					loading.close()
					if (res.code == 0) {
						if(this.direct){
							this.order = res.data;
							this.dialogSettlementState = true;
						}else{
							this.$message({
								message: '操作成功',
								type:'success'
							});
							this.$store.commit('recharge/set_type','list')
						}
					}
				})
			},
			// 结算
			dialogSettlementSubmit(a){
				this.dialogSettlementState = false;
				if(a=='cancel'){
					console.log(a)
				}else if(a=='fail'){
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				}else if(a=='success'){
					this.$message({
						message: '结算成功',
						type: 'success'
					});
					this.$store.dispatch("mendian/getUserInfo",this.userInfo._id)
					this.$store.commit('recharge/set_type','list')
				}
			},
			// 备注
			openBeizhu(){
				this.drawerRemark_state=true;
			},
			submit_drawerRemark(){
				this.drawerRemark_state=false;
			},
			// 礼品卡充值
			submit_giftCardRecharge(obj){
				this.giftCardRecharge_state = false;
				if(obj.type==='success'){
					this.$message({
						message: '操作成功',
						type: 'success'
					});
				}
			},
		}
	}
</script>
<style scoped lang="scss">
.panel_shouyin{
	background-color: #fff;height: 100%;position: relative;
	// .titleLine{
	// 	width:100%;box-sizing: border-box;position: absolute;top:0;z-index: 1;background-color: #fff;
	// }
	.con{
		height: 100%;padding:60px 0 60px 0;overflow: auto;box-sizing: border-box;
		.rechargeBox{
			display: inline-flex;flex-wrap: wrap;
			.rechargeItem{
				position: relative;width:141px;height: 80px;box-sizing: border-box;text-align: center;color:$fontColor;font-size: 14px;border-radius: 2px;margin-top:15px;margin-right:20px;cursor: pointer;background-image: url(../../../../assets/img/mendian/recharge.png);background-size: 100% 100%;
				&.active{
					background-image: url(../../../../assets/img/mendian/recharge1.png);color:$mainColor;
				}
				.checked{
					position: absolute;right:0;bottom:0;width:26px;height: 13px;text-align: center;color:#fff;
				}
			}
		}
	}
	.msg{
		display: flex;
		flex-wrap: wrap;
		padding:0 30px;
		background-color: #fff;
		.msgItem{
			width:280px;
			font-size: 16px;
			color:#1A1A1A;
			display: flex;
			line-height: 50px;;
			.msgLabel{
				width:120px;
				text-align: right;
				color:#999999;
			}
			.msgValue{
				
			}
		}
	}
	.pageConBox{
		padding:0 20px;
		min-height: 600px;
	}
	.panel_settlement{
		position: absolute;
		z-index: 110;
		bottom:0;
		width:100%;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;
		padding:10px 20px;
		background-color: #fff;
		box-shadow: 0 -3px 3px 0px #f5f5f5;
		.priceItem{
			display: inline-flex;align-items: center;
			margin-right: 40px;
			.label{
				font-size: 14px;color:$fontColor;
			}
			.price{
				font-size: 20px;color:$fontColor;
			}
		}
	}
}
</style>
